import React, { useState, useEffect } from 'react';
import { X, AlertTriangle } from 'lucide-react';
import { API } from '../utils/api';

const DISMISS_KEY = 'il_trullo_alert_dismissed';

const AlertBanner = () => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchAlert = async () => {
      try {
        const response = await fetch(`${API}/settings`);
        if (!response.ok) return;
        const data = await response.json();
        if (data.alert_active && data.alert_message) {
          // Check if this exact message was already dismissed in this session
          const dismissed = sessionStorage.getItem(DISMISS_KEY);
          if (dismissed !== data.alert_message) {
            setMessage(data.alert_message);
            setVisible(true);
          }
        }
      } catch {
        // Silent fail
      }
    };
    fetchAlert();
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, message);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="alert-banner"
      className="fixed top-0 left-0 right-0 z-[60] bg-amber-400 text-amber-900 py-2.5 px-4 flex items-center justify-center gap-3 shadow-md text-sm font-medium"
    >
      <AlertTriangle className="w-4 h-4 flex-shrink-0" />
      <span>{message}</span>
      <button
        data-testid="alert-banner-dismiss"
        onClick={dismiss}
        className="ml-2 p-1 hover:bg-amber-500 rounded-full transition-colors"
        aria-label="Fermer"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default AlertBanner;
